import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function AdminSubscriptionEvents() {
  const [subs, setSubs] = useState([]);
  const [loadingSubs, setLoadingSubs] = useState(true);
  const [selectedSub, setSelectedSub] = useState(null);

  const [events, setEvents] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(false);

  useEffect(() => {
    fetchSubs();
  }, []);

  async function fetchSubs() {
    setLoadingSubs(true);
    const { data, error } = await supabase
      .from("subscriptions")
      .select(`
        id,
        plan,
        status,
        current_period_start,
        current_period_end,
        trial_end,
        stripe_subscription_id,
        profiles (
          id,
          email,
          role
        )
      `)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Erreur fetch subs:", error.message);
    } else {
      setSubs(data);
    }
    setLoadingSubs(false);
  }

  async function fetchEventsForSub(stripeSubscriptionId) {
    if (!stripeSubscriptionId) return;
    setLoadingEvents(true);
    const { data, error } = await supabase
      .from("subscription_events")
      .select(`
        id,
        event_type,
        created_at,
        stripe_invoice_id,
        stripe_session_id,
        raw
      `)
      .eq("stripe_subscription_id", stripeSubscriptionId)
      .order("created_at", { ascending: false })
      .limit(50);

    if (error) {
      console.error("Erreur fetch events:", error.message);
      setEvents([]);
    } else {
      setEvents(data);
    }
    setLoadingEvents(false);
  }

  const handleSelect = (sub) => {
    setSelectedSub(sub);
    fetchEventsForSub(sub.stripe_subscription_id);
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">📊 Abonnements + événements liés</h1>

      {/* Tableau abonnements */}
      {loadingSubs ? (
        <p>Chargement des abonnements…</p>
      ) : (
        <div className="overflow-x-auto border rounded mb-8">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2">Utilisateur</th>
                <th className="p-2">Rôle</th>
                <th className="p-2">Plan</th>
                <th className="p-2">Statut</th>
                <th className="p-2">Trial end</th>
                <th className="p-2">Période</th>
                <th className="p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {subs.map((s) => (
                <tr
                  key={s.id}
                  className={`border-t cursor-pointer hover:bg-gray-50 ${
                    selectedSub?.id === s.id ? "bg-indigo-50" : ""
                  }`}
                  onClick={() => handleSelect(s)}
                >
                  <td className="p-2">{s.profiles?.email ?? "—"}</td>
                  <td className="p-2 capitalize">{s.profiles?.role ?? "—"}</td>
                  <td className="p-2">{s.plan}</td>
                  <td className="p-2">{s.status}</td>
                  <td className="p-2">
                    {s.trial_end
                      ? new Date(s.trial_end).toLocaleDateString()
                      : "—"}
                  </td>
                  <td className="p-2">
                    {s.current_period_start
                      ? new Date(s.current_period_start).toLocaleDateString()
                      : "—"}{" "}
                    →{" "}
                    {s.current_period_end
                      ? new Date(s.current_period_end).toLocaleDateString()
                      : "—"}
                  </td>
                  <td className="p-2">
                    <button
                      className="px-2 py-1 text-sm bg-indigo-600 text-white rounded"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelect(s);
                      }}
                    >
                      Voir événements
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Panneau événements */}
      {selectedSub && (
        <div className="border rounded p-4 bg-white">
          <h2 className="text-xl font-semibold mb-4">
            Événements liés à l’abonnement de {selectedSub.profiles?.email}
          </h2>
          {loadingEvents ? (
            <p>Chargement des événements…</p>
          ) : events.length === 0 ? (
            <p>Aucun événement enregistré pour cet abonnement.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2">Date</th>
                    <th className="p-2">Type</th>
                    <th className="p-2">Invoice</th>
                    <th className="p-2">Session</th>
                    <th className="p-2">Détails</th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((ev) => (
                    <tr key={ev.id} className="border-t">
                      <td className="p-2">
                        {new Date(ev.created_at).toLocaleString()}
                      </td>
                      <td className="p-2">{ev.event_type}</td>
                      <td className="p-2 truncate max-w-[140px]">
                        {ev.stripe_invoice_id ?? "—"}
                      </td>
                      <td className="p-2 truncate max-w-[140px]">
                        {ev.stripe_session_id ?? "—"}
                      </td>
                      <td className="p-2">
                        <details>
                          <summary className="cursor-pointer text-blue-600">
                            JSON
                          </summary>
                          <pre className="text-xs bg-gray-50 p-2 rounded overflow-auto max-h-56">
                            {JSON.stringify(ev.raw, null, 2)}
                          </pre>
                        </details>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
